import React from 'react'
import PropTypes from 'prop-types'

import Header from '@/checkout-instore-legacy/package/components/PackageSelector/Header'

const PackageHeader = ({
  pkg,
  numOfPackages,
  className,
  order,
  setOrderPlacedInfo,
}) => (
  <Header
    editable={false}
    pkg={pkg}
    numOfPackages={numOfPackages}
    className={className}
    order={order}
    setOrderPlacedInfo={setOrderPlacedInfo}
    pkgType="order-placed"
  />
)

PackageHeader.propTypes = {
  pkg: PropTypes.object,
  numOfPackages: PropTypes.number,
  className: PropTypes.string,
  order: PropTypes.object,
  setOrderPlacedInfo: PropTypes.func,
}

export default PackageHeader
